import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function RussiaFlagIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
        fill="#F0F0F0"
      />
      <path
        d="M30.067 21.2199C30.67 19.5949 31 17.8373 31 16.0025C31 14.1677 30.67 12.4101 30.067 10.7852H1.93299C1.33006 12.4101 1 14.1677 1 16.0025C1 17.8373 1.33006 19.5949 1.93299 21.2199L16 22.5242L30.067 21.2199Z"
        fill="#0052B4"
      />
      <path
        d="M15.9996 30.9975C22.4491 30.9975 27.9472 26.9269 30.0666 21.2148H1.93262C4.05201 26.9269 9.55016 30.9975 15.9996 30.9975Z"
        fill="#D80027"
      />
    </BaseIcon>
  );
}
